import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as ApexCharts from 'apexcharts';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-action-items',
	templateUrl: './action-items.component.html',
	styleUrls: ['./action-items.component.scss']
})
export class ActionItemsComponent implements OnInit {

	page_tab_selected: any = "Activities";

	user_details: any;
	user_role: any;

	type: any = "";
	tab: any = "";

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private datePipe: DatePipe,
		private router: Router,
		private route: ActivatedRoute,
	) { }

	ngOnInit(): void {
		// this.test();
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
			this.activities_table_header = this.executive_manager_header;
			this.activity_type_filter = "All";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
			this.activities_table_header = this.advisor_manager_header;
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
			this.activities_table_header = this.advisor_header;
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
			this.activities_table_header = this.afa_header;
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
			this.activities_table_header = this.assistant_header;
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
			this.activities_table_header = this.relationship_manager_header;
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
			this.activities_table_header = this.leadership_team_header;
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
			this.activities_table_header = this.marketing_team_header;
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
			this.activities_table_header = this.wholesaler_header;
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
			this.activities_table_header = this.lending_officer_header;
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
			this.activities_table_header = this.insurance_agent_header;
		}

		this.route.params.subscribe((params) => {
			this.type = params['type'];
			this.tab = params['tab'];
		});


		if (this.tab == "activities") {
			this.page_tab_selected = "Activities"
			this.changePageTab("Activities");
		} else if (this.tab == "notifications") {
			this.page_tab_selected = "Notifications";
			this.notification_tab_selected = "Internal Notifications";
			// this.getNotifications();
      this.changePageTab("Notifications");
		} else if (this.tab == "pending-activities") {
			this.page_tab_selected = "Notifications";
			this.notification_tab_selected = "Pending Activities";
			// this.getNotifications();
      this.changePageTab("Notifications");
		} else if (this.tab == "results") {
			this.page_tab_selected = "Results";
      this.changePageTab("Results");
		} else {
			this.page_tab_selected = "Activities"
			this.changePageTab("Activities");
		}

		// this.changePageTab("Activities");

		if (this.user_role != "Wholesaler") {
			this.getStages();
		}
		this.getStatusList();


	}

	stages_list: any = [];
	getStages() {
		this.commonService.getData('/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + "&business_area=" + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
        		this.stages_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatusList() {
		this.commonService.getData('/status/?no_page=true').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	changePageTab(value) {
		this.page_tab_selected = value;

		let role: any = "";
		if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
			role = '/insurance-agent';
		}

		if (this.user_details.role.role != 3 && this.user_details.role.role != 10) {
			if (this.page_tab_selected == "Activities") {
				this.router.navigate([role + '/action-items/activities']);
			} else if (this.page_tab_selected == "Notifications") {
        // if (this.tab == "notifications") {
			  //   this.router.navigate([role + '/action-items/notifications']);
        // } else if (this.tab == "pending-activities") {
				//   this.router.navigate([role + '/action-items/pending-activities']);
        // }
        this.router.navigate([role + '/action-items/notifications']);
			} else if (this.page_tab_selected == "Results") {
				this.router.navigate([role + '/action-items/results']);
		  }
		} else {
			this.router.navigate([role + '/action-items']);
		}

		if (this.page_tab_selected == "Activities") {
			// this.getActionItemGraphs();
			this.changeDuration("Selected");
		} else if (this.page_tab_selected == "Notifications") {
			this.getNotifications();
		} else if (this.page_tab_selected == "Results") {
      this.getResultsData();
    }
	}

	action_item_filter_tabs: any = [
		{
			id: 1,
			name: "Day",
			value: "day"
		},
		{
			id: 2,
			name: "Weekly",
			value: "week"
		},
		{
			id: 3,
			name: "Monthly",
			value: "month"
		},
		// {
		// id: 4,
		// 	name: "Quarterly",
		// 	value: "quarter"
		// },
		{
			id: 5,
			name: "Yearly",
			value: "year"
		},
	];
	action_item_filter_tab_selected: any = {
		id: 1,
		name: "Day",
		value: "day"
	};
	// action_item_filter_tab_selected: any = {
	// 	id: 3,
	// 	name: "Monthly",
	// 	value: "month"
	// };
	changeActionItemDuration(data) {
		this.action_item_filter_tab_selected = data;
		// this.getActionItemGraphs();
		this.changeDuration("Selected");
	}

	changeDuration(type) {
		if (type == "Previous") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getPreviousDay();
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getPreviousWeek();
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getPreviousMonth();
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getPreviousYear();
			}
		} else  if (type == "Next") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getNextDay();
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getNextWeek();
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getNextMonth();
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getNextYear();
			}
		} else  if (type == "Selected") {
			if (this.action_item_filter_tab_selected.value == "day") {
				this.getSelectedDay(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "week") {
				this.getSelectedWeek(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "month") {
				this.getSelectedMonth(this.selceted_activity_start_date);
			} else if (this.action_item_filter_tab_selected.value == "year") {
				this.getSelectedYear(this.selceted_activity_start_date);
			}
		}
	}

	action_item_tabs: any = [
		{
			name: "Email Follow-ups",
			value: "Email Follow-ups"
		},
		{
			name: "F2F Meetings",
			value: "F2F Meetings"
		},
		{
			name: "Calls",
			value: "Calls"
		},
		// {
		// 	name: "Conferences",
		// 	value: "Conferences"
		// },
		{
			name: "Virtual Meeting",
			value: "Virtual Meeting"
		},
		{
			name: "Other",
			value: "Other"
		},
	];

	action_item_tab_selected: any = "Email Follow-ups";
	changeActionItemTab(data) {
		this.action_item_tab_selected = data.value;
		this.segregateActionItemTabData();
	}

	action_items_table_data: any = [];
	action_items_table_data_loaded: boolean = false;
	segregateActionItemTabData() {
		this.action_items_table_data_loaded = false;
		if (this.action_item_tab_selected == "Email Follow-ups") {
			this.action_items_table_data = this.action_items_data["action_items"]["email"];
		} else if (this.action_item_tab_selected == "F2F Meetings") {
			this.action_items_table_data = this.action_items_data["action_items"]["meeting"];
		} else if (this.action_item_tab_selected == "Calls") {
			this.action_items_table_data = this.action_items_data["action_items"]["call"];
		} else if (this.action_item_tab_selected == "Conferences") {
			this.action_items_table_data = this.action_items_data["action_items"]["conference"];
		} else if (this.action_item_tab_selected == "Virtual Meeting") {
			this.action_items_table_data = this.action_items_data["action_items"]["virtual_meeting"];
		} else if (this.action_item_tab_selected == "Other") {
			this.action_items_table_data = this.action_items_data["action_items"]["other"];
		}
		this.action_items_table_data_loaded = true;
	}

	notification_tabs: any = [
		{
			name: "Internal Notifications",
			value: "Internal Notifications"
		},
		{
			name: "Pending Activities",
			value: "Pending Activities"
		},
	];

	notification_tab_selected: any = "Internal Notifications";
	changeNotificationTab(data) {
		this.notification_tab_selected = data.value;

		let role: any = "";
		if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
			role = '/insurance-agent';
		}

		// if (this.notification_tab_selected == "Internal Notifications") {
		// 	this.router.navigate([role + '/action-items/notifications']);
		// } else if (this.notification_tab_selected = "Pending Activities") {
		// 	this.router.navigate([role + '/action-items/pending-activities']);
		// }

		if (this.user_details.role.role != 3 && this.user_details.role.role != 10) {
			if (this.notification_tab_selected == "Internal Notifications") {
				this.router.navigate([role + '/action-items/notifications']);
			} else if (this.notification_tab_selected = "Pending Activities") {
				this.router.navigate([role + '/action-items/pending-activities']);
			}
		} else {
			this.router.navigate([role + '/action-items']);
		}

	}

	activity_stage_filter: any = "All";
	client_stage_filter: any = "All";
	status_filter: any = "All";
	importance_filter: any = "All";
	activity_type_filter: any = "Manual";
	// activity_type_filter: any = 'All';
	assigned_filter: any = "All";

	action_items_data_loaded: boolean = false;
	action_items_data: any;
	getActionItemGraphs() {

		this.action_items_data_loaded = false;

		const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		let route: any = "";
		if (this.user_role == "Executive") {
			route = "/executivetodo/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Advisor Manager") {
			route = "/advisormanagernewtodo/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Advisor") {
			// advisortodonew
			route = "/advisortodonewupdated/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter+ "&assigned_filter=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "AFA") {
			route = "/afatodonew/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Assistant") {
			route = "/assistanttodoupdated/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Relationship Manager") {
			// route = "/relationshipmanagertodonew/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
			route = "/advisortodonewupdated/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter+ "&assigned_filter=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Leadership") {
			// route = "/leadershiptodo/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
			route = "/recruitertodo/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Marketing Team") {
			route = "/marketingteamtodo/?duration=" + this.action_item_filter_tab_selected.value + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter+ '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Lending Officer") {
			route = "/advisortodonewupdated/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter+ "&assigned_filter=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Insurance Agent") {
			route = "/advisortodonewupdated/?duration=" + this.action_item_filter_tab_selected.value + '&activity_stage_filter=' + this.activity_stage_filter + '&client_stage_filter=' + this.client_stage_filter + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter+ "&assigned_filter=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Wholesaler") {
			route = "/wholesalertodo/?duration=" + this.action_item_filter_tab_selected.value + '&status_filter=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		}

		if (userTimezone != "") {
			route = route + "&time_zone=" + userTimezone;
		}

		if (this.selceted_activity_start_date != "") {
			route = route + "&start_date=" + this.datePipe.transform(this.selceted_activity_start_date, 'yyyy-MM-dd');
		}

		if (this.selceted_activity_end_date != "") {
			route = route + "&end_date=" + this.datePipe.transform(this.selceted_activity_end_date, 'yyyy-MM-dd');
		}

		if (this.graph_activity_status_id != "") {
			route = route + "&status=" + this.graph_activity_status_id;
		}

		if (this.graph_activity_communication_channel_id != "") {
			route = route + "&communication_type=" + this.graph_activity_communication_channel_id;
		}

		if (this.graph_activity_duration_id != "") {
			route = route + "&selected_duration=" + this.graph_activity_duration_id;
		}

		if (this.graph_activity_importance_id != "") {
			route = route + "&importance=" + this.graph_activity_importance_id;
		}

		if (this.graph_activity_stage_id != "") {
			route = route + "&stage=" + this.graph_activity_stage_id;
		}

		if (this.graph_activity_type_id != "") {
			route = route + "&type=" + this.graph_activity_type_id;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.action_items_data = res['data'];

				this.segregateActionItemTabData();

				this.action_items_data_loaded = true;

				this.toggleGraphs();

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	show_graphical_representation: boolean = false;
	toggleGraphs() {
		if (this.show_graphical_representation == true) {
			setTimeout(() => {

				// Version 1
				// this.createActivityStatusGraph();
				// this.createCommunicationChannelStatusGraph();
				// this.createCommunicationChannelDurationGraph();
				// this.createCommunicationChannelImportanceGraph();
				// this.createCommunicationChannelStageGraph();
				// this.createActivityTypeGraph();
				// this.createTopTrendsGraph();
				// this.createAIAssistantGraph();

				// Version 2
				this.createDurationGraph();
				this.createCommunicationChannelRadarGraph();


				if (this.user_role != 'Advisor Manager' && this.user_role != 'Executive' && this.user_role != 'Leadership' && this.user_role != 'Marketing Team' && this.user_role != 'Assistant' && this.user_role != 'Wholesaler') {
					this.createStagesGraph();
					if (this.user_role != 'Wholesaler') {
						this.createAIAssistantLineGraph();
					}
				} else if (this.user_role != 'Advisor Manager' && this.user_role != 'Executive' && this.user_role != 'Marketing Team' && this.user_role != 'Assistant') {
					this.createActivityTypeDonutChart();
				} else {
					this.createAdvisorManagerStagesGraph();
				}
			}, 200);
		}
	}

	graph_activity_status: any = '';
	graph_activity_status_id: any = '';

	graph_activity_communication_channel: any = '';
	graph_activity_communication_channel_id: any = '';

	graph_activity_duration: any = '';
	graph_activity_duration_id: any = '';

	graph_activity_importance: any = '';
	graph_activity_importance_id: any = '';

	graph_activity_stage: any = '';
	graph_activity_stage_id: any = '';

	graph_activity_type: any = '';
	graph_activity_type_id: any = '';

	// Version 1
	createActivityStatusGraph() {
		let $this = this;

		const options = {
			colors: $this.action_items_data["status_pie_chart"]['colors'],
			series: $this.action_items_data["status_pie_chart"]['data'],
			chart: {
				type: 'pie',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.action_items_data['status_pie_chart']['ids'][config.dataPointIndex],
							name: $this.action_items_data['status_pie_chart']['labels'][config.dataPointIndex],
						};
						$this.graph_activity_status_id = details.id;
						$this.graph_activity_status = details.name;

						$this.getActionItemGraphs();
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.action_items_data["status_pie_chart"]['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#activity-status-graph'), options);
		chart.render();

	}

	createCommunicationChannelStatusGraph() {
		let $this = this;
		var options = {
			colors: $this.action_items_data['comm_status_chart']['colors'],
			series: $this.action_items_data['comm_status_chart']['y-axis'],
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							channel: $this.action_items_data["comm_status_chart"]["x-axis"][config.dataPointIndex],
							channel_id: $this.action_items_data["comm_status_chart"]["communication_type_ids"][config.dataPointIndex],

							status: $this.action_items_data["comm_status_chart"]["labels"][config.seriesIndex],
							status_id: $this.action_items_data["comm_status_chart"]["status_ids"][config.seriesIndex],
						};

						$this.graph_activity_communication_channel = details.channel;
						$this.graph_activity_communication_channel_id = details.channel_id;

						$this.graph_activity_status = details.status;
						$this.graph_activity_status_id = details.status_id;
						$this.getActionItemGraphs();
					}
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('channel-status-graph').clientWidth, $this.action_items_data['comm_status_chart']['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.action_items_data['comm_status_chart']['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#channel-status-graph'), options);
		chart.render();
	}

	createCommunicationChannelDurationGraph() {
		let $this = this;
		var options = {
			colors: $this.action_items_data['daywise_chart']['colors'],
			series: $this.action_items_data['daywise_chart']['y-axis'],
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							duration: $this.action_items_data["daywise_chart"]["x-axis"][config.dataPointIndex],
							duration_id: $this.action_items_data["daywise_chart"]["x-axis"][config.dataPointIndex],

							channel: $this.action_items_data["daywise_chart"]["labels"][config.seriesIndex],
							channel_id: $this.action_items_data["daywise_chart"]["communication_type_ids"][config.seriesIndex],
						};
						$this.graph_activity_communication_channel = details.channel;
						$this.graph_activity_communication_channel_id = details.channel_id;

						$this.graph_activity_duration = details.duration;
						$this.graph_activity_duration_id = details.duration_id;
						$this.getActionItemGraphs();
					}
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('channel-duration-graph').clientWidth, $this.action_items_data['daywise_chart']['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.action_items_data['daywise_chart']['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#channel-duration-graph'), options);
		chart.render();
	}

	createCommunicationChannelImportanceGraph() {
		let $this = this;
		var options = {
			colors: $this.action_items_data['comm_importance_chart']['colors'],
			series: $this.action_items_data['comm_importance_chart']['y-axis'],
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							channel: $this.action_items_data["comm_importance_chart"]["x-axis"][config.dataPointIndex],
							channel_id: $this.action_items_data["comm_importance_chart"]["communication_type_ids"][config.dataPointIndex],

							importance: $this.action_items_data["comm_importance_chart"]["labels"][config.seriesIndex],
							importance_id: $this.action_items_data["comm_importance_chart"]["importance_ids"][config.seriesIndex],
						};
						$this.graph_activity_communication_channel = details.channel;
						$this.graph_activity_communication_channel_id = details.channel_id;

						$this.graph_activity_importance = details.importance;
						$this.graph_activity_importance_id = details.importance_id;
						$this.getActionItemGraphs();
					}
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('channel-importance-graph').clientWidth, $this.action_items_data['comm_importance_chart']['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.action_items_data['comm_importance_chart']['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#channel-importance-graph'), options);
		chart.render();
	}

	createCommunicationChannelStageGraph() {
		let $this = this;
		var options = {
			colors: $this.action_items_data['comm_stage_chart']['colors'],
			series: $this.action_items_data['comm_stage_chart']['y-axis'],
			chart: {
				type: 'bar',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							stage: $this.action_items_data["comm_stage_chart"]["x-axis"][config.dataPointIndex],
							stage_id: $this.action_items_data["comm_stage_chart"]["stage_ids"][config.dataPointIndex],

							channel: $this.action_items_data["comm_stage_chart"]["labels"][config.seriesIndex],
							channel_id: $this.action_items_data["comm_stage_chart"]["communication_type_ids"][config.seriesIndex],
						};
						$this.graph_activity_communication_channel = details.channel;
						$this.graph_activity_communication_channel_id = details.channel_id;

						$this.graph_activity_stage = details.stage;
						$this.graph_activity_stage_id = details.stage_id;
						$this.getActionItemGraphs();
					}
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('channel-stage-graph').clientWidth, $this.action_items_data['comm_stage_chart']['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.action_items_data['comm_stage_chart']['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#channel-stage-graph'), options);
		chart.render();
	}

	createActivityTypeGraph() {
		let $this = this;
		var options = {
			colors:  $this.action_items_data['type_graph']['colors'],
			series: [
				{
					name: '',
					data: $this.action_items_data['type_graph']['data'],
				},
			],
			chart: {
				type: 'pie',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.action_items_data['type_graph']['ids'][config.dataPointIndex],
							name: $this.action_items_data['type_graph']['labels'][config.dataPointIndex],
						};


						$this.graph_activity_type_id = details.id;
						$this.graph_activity_type = details.name;

						$this.getActionItemGraphs();
					},
				},
				toolbar: {
				show: false,
				},
				zoom: {
				enabled: false,
				},
				height: 280,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("activity-type-graph").clientWidth,
						$this.action_items_data['type_graph']['labels'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.action_items_data['type_graph']['labels'],
				title: {
					// text: 'Age Range'
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
				  formatter: function (val) {
				    return val
				  }
				}
			},
		};
		var chart = new ApexCharts(document.querySelector('#activity-type-graph'), options);
		chart.render();
	}

	createTopTrendsGraph() {
		let $this = this;
		var options = {
			colors:  $this.action_items_data['top_trends']['colors'],
			series: [
				{
					name: '',
					data: $this.action_items_data['top_trends']['data'],
				},
			],
			chart: {
				type: 'bar',
				toolbar: {
				show: false,
				},
				zoom: {
				enabled: false,
				},
				height: 280,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("top-trends-graph").clientWidth,
						$this.action_items_data['top_trends']['labels'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.action_items_data['top_trends']['labels'],
				title: {
					// text: 'Age Range'
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
				  formatter: function (val) {
				    return val
				  }
				}
			},
		};
		var chart = new ApexCharts(document.querySelector('#top-trends-graph'), options);
		chart.render();
	}

	createAIAssistantGraph() {
		let $this = this;
		var options = {
			colors:  $this.action_items_data['ai_assistant']['colors'],
			series: [
				{
					name: '',
					data: $this.action_items_data['ai_assistant']['data'],
				},
			],
			chart: {
				type: 'bar',
				toolbar: {
				show: false,
				},
				zoom: {
				enabled: false,
				},
				height: 280,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById("ai-assistant-graph").clientWidth,
						$this.action_items_data['ai_assistant']['labels'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.action_items_data['ai_assistant']['labels'],
				title: {
					// text: 'Age Range'
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				y: {
				  formatter: function (val) {
				    return val
				  }
				}
			},
		};
		var chart = new ApexCharts(document.querySelector('#ai-assistant-graph'), options);
		chart.render();
	}


	// Version 2
	selcted_graph_stage: any = "Upside";
	stage_graph: any = null;
	createStagesGraph() {
		let $this = this;


		let graph_data: any;
		if ($this.selcted_graph_stage == "Upside") {
			graph_data = $this.action_items_data['opp_stage_chart'];
		} else if ($this.selcted_graph_stage == "Retention") {
			graph_data = $this.action_items_data['retention_stage_chart'];
		} else if ($this.selcted_graph_stage == "New") {
			graph_data = $this.action_items_data['new_stage_chart'];
		}

		if ($this.stage_graph) {
			$this.stage_graph.destroy();
			$this.stage_graph = null;
		}

		var options = {
			colors: graph_data['colors'],
			series: graph_data['y-axis'],
			chart: {
				type: 'bar',
				// events: {
				// 	dataPointSelection: function (event, chartContext, config) {
				// 		const details = {
				// 			stage: graph_data["x-axis"][config.dataPointIndex],
				// 			stage_id: graph_data["stage_ids"][config.dataPointIndex],

				// 			status: graph_data["labels"][config.seriesIndex],
				// 			status_id: graph_data["status_ids"][config.seriesIndex],
				// 		};
				// 		$this.graph_activity_status = details.status;
				// 		$this.graph_activity_status_id = details.status_id;

				// 		$this.graph_activity_stage = details.stage;
				// 		$this.graph_activity_stage_id = details.stage_id;
				// 		$this.getActionItemGraphs();
				// 	}
				// },
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('sale-process-graph').clientWidth, graph_data['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: graph_data['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		$this.stage_graph = new ApexCharts(document.querySelector('#sale-process-graph'), options);
		$this.stage_graph.render();
	}

	createDurationGraph() {
		let $this = this;
		var options = {
		series: $this.action_items_data['day_chart'],
		colors: ['#008FFB'],
		chart: {
			height: 300,
			toolbar: {
			show: false,
			},
			zoom: {
			enabled: false,
			},
			type: 'heatmap',
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			heatmap: {
			shadeIntensity: 0.5,
			radius: 0,
			useFillColorAsStroke: false,
			// colorScale: {
			//   ranges: [{
			//       from: -30,
			//       to: 5,
			//       name: 'low',
			//       color: '#00A100'
			//     },
			//     {
			//       from: 6,
			//       to: 20,
			//       name: 'medium',
			//       color: '#128FD9'
			//     },
			//     {
			//       from: 21,
			//       to: 45,
			//       name: 'high',
			//       color: '#FFB200'
			//     },
			//     {
			//       from: 46,
			//       to: 55,
			//       name: 'extreme',
			//       color: '#FF0000'
			//     }
			//   ]
			// }
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			width: 1,
		},
		title: {
			// text: 'HeatMap Chart with Color Range'
			text: '',
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {

				if ($this.action_items_data['day_chart'][seriesIndex].data[dataPointIndex].selected_date != "" && $this.action_items_data['day_chart'][seriesIndex].data[dataPointIndex].selected_date != null) {
					let tooltip_template: any = "";

					tooltip_template = tooltip_template + '<div style="padding: 20px; border-radius: 4px; box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1); background: #FFFFFF; width: 300px">';

						tooltip_template = tooltip_template + '<p style="font-size: 20px; color: #000000; padding-bottom: 12px; border-bottom: 1px solid #D3D3D3; margin-bottom: 16px;"> Total Activities';

						tooltip_template = tooltip_template + '</p>';


						tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 14px; color: #000000; margin-bottom: 12px;"';
							if ($this.action_item_filter_tab_selected.value == "year") {
								tooltip_template = tooltip_template + '<span>Month' + '</span>';
							} else {
								tooltip_template = tooltip_template + '<span>Date' + '</span>';
							}

							tooltip_template = tooltip_template + '<span>' + $this.action_items_data['day_chart'][seriesIndex].data[dataPointIndex].selected_date + '</span>';

						tooltip_template = tooltip_template + '</div>';

						tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 14px; color: #000000; margin-bottom: 12px;"';
							tooltip_template = tooltip_template + '<span>Count' + '</span>';

							tooltip_template = tooltip_template + '<span>' + $this.action_items_data['day_chart'][seriesIndex].data[dataPointIndex].y + '</span>';

						tooltip_template = tooltip_template + '</div>';

					tooltip_template = tooltip_template + '</div>';


					return (tooltip_template);
				} else {
					return "";
				}
			},
			// fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};
		var chart = new ApexCharts(document.querySelector('#channel-duration-graph'), options);
		chart.render();
	}

	createCommunicationChannelRadarGraph() {
		let $this = this;
		let label_colors: any = [];

		for (let index = 0; index < $this.action_items_data["radar_chart"]["x-axis"].length; index++) {
			label_colors.push("#000000");
		}

		var options = {
			colors: $this.action_items_data["radar_chart"]['colors'],
			series: [{
				name: '',
				data: $this.action_items_data["radar_chart"]["y-axis"],
				// data: [10, 20, 30, 10, 40, 66, 11, 33, 22, 77],
			}],
			chart: {
				type: 'radar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			plotOptions: {
				radar: {
				  size: 140,
				  offsetX: 0,
				  offsetY: 10,
				  polygons: {
					strokeColors: '#858a90',
					strokeWidth: 1,
					connectorColors: '#858a90',
					// fill: {
					// 	colors: ['#f8f8f8', '#fff']
					// }
				  }
				}
			  },
			title: {
				text: ''
			},
			yaxis: {
				// stepSize: 20
			},
			xaxis: {
				categories: $this.action_items_data["radar_chart"]["x-axis"],
				labels: {
					style: {
					//   colors: $this.action_items_data["radar_chart"]['colors']
					  colors: label_colors
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector("#activity-channel-graph"), options);
		chart.render();
	}

	createActivityTypeDonutChart() {
		let $this = this;

		const options = {
			colors: $this.action_items_data["new_type_graph"]['colors'],
			series: $this.action_items_data["new_type_graph"]['data'],
			chart: {
				type: 'donut',
				// events: {
				// 	dataPointSelection: function (event, chartContext, config) {
				// 		const details = {
				// 			id: $this.action_items_data['new_type_graph']['ids'][config.dataPointIndex],
				// 			name: $this.action_items_data['new_type_graph']['labels'][config.dataPointIndex],
				// 		};
				// 		$this.graph_activity_type_id = details.id;
				// 		$this.graph_activity_type = details.name;

				// 		$this.getActionItemGraphs();
				// 	},
				// },
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.action_items_data["new_type_graph"]['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				// custom: function ({ series, seriesIndex, dataPointIndex, w }) {
				// 	let tooltip_template: any = "";

				// 	tooltip_template = tooltip_template + '<div style="padding: 20px; border-radius: 4px; box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1); background: #FFFFFF; width: 300px">';

				// 		// tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 20px; color: #000000; padding-bottom: 12px; border-bottom: 1px solid #D3D3D3; margin-bottom: 16px;"';
				// 		tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 20px; color: #000000; padding-bottom: 12px; border-bottom: 1px solid #D3D3D3; margin-bottom: 0px;"';
				// 			tooltip_template = tooltip_template + '<span>' + $this.action_items_data["new_type_graph"]['labels'][seriesIndex] + '</span>';

				// 			tooltip_template = tooltip_template + '<span>' + $this.action_items_data["new_type_graph"]['data'][seriesIndex] + '</span>';

				// 		tooltip_template = tooltip_template + '</div>';

				// 		// tooltip_template = tooltip_template + '<div style="max-height: 200px; overflow-y: auto;">';

				// 		if  ($this.action_items_data["new_type_graph"]['breakdown'][seriesIndex].length > 0) {
				// 			for (let index = 0; index < $this.action_items_data["new_type_graph"]['breakdown'][seriesIndex].length; index++) {
				// 				const data = $this.action_items_data["new_type_graph"]['breakdown'][seriesIndex][index];
				// 				// tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 14px; color: #000000; margin-bottom: 12px;"';
				// 				tooltip_template = tooltip_template + '<div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; font-size: 14px; color: #000000; margin-top: 12px;"';
				// 					tooltip_template = tooltip_template + '<span>' + data.name + '</span>';

				// 					tooltip_template = tooltip_template + '<span>' + data.count + '</span>';

				// 				tooltip_template = tooltip_template + '</div>';
				// 			}
				// 		}

				// 		// tooltip_template = tooltip_template + '</div>';

				// 	tooltip_template = tooltip_template + '</div>';


				// 	return (tooltip_template);

				// },
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};

		var chart = new ApexCharts(document.querySelector('#activity-type-graph'), options);
		chart.render();
	}

	createAIAssistantLineGraph() {
		let $this = this;
		var options = {
			colors: $this.action_items_data["ai_assistant_advisor_graph"]['colors'],
			series: $this.action_items_data["ai_assistant_advisor_graph"]['y-axis'],
			chart: {
			  height: 280,
			  type: 'line',
			//   events: {
			// 	dataPointSelection: function (event, chartContext, config) {
			// 		const details = {
			// 			channel: $this.action_items_data["ai_assistant_advisor_graph"]["labells"][config.dataPointIndex],
			// 			channel_id: $this.action_items_data["ai_assistant_advisor_graph"]["communication_type_ids"][config.dataPointIndex],
			// 		};
			// 		$this.graph_activity_communication_channel = details.channel;
			// 		$this.graph_activity_communication_channel_id = details.channel_id;
			// 		$this.getActionItemGraphs();
			// 	}
			// 	},
			  toolbar: {
				show: false,
			  },
			  zoom: {
				enabled: false,
			  },
			},
			noData: {
			  text: 'No Data Available',
			  align: 'center',
			  verticalAlign: 'middle',
			  offsetX: 0,
			  offsetY: 0,
			  style: {
				color: '#006AFF',
				fontSize: '24px',
				fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			  },
			},
			dataLabels: {
			  enabled: false,
			},
			stroke: {
			  // curve: 'straight',
			  curve: 'smooth',
			  width: 2,
			},
			title: {
			  text: '',
			  align: 'left',
			},
			legend: {
			  fontSize: '14px',
			  fontWeight: 600,
			  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			  itemMargin: {
				horizontal: 10,
				vertical: 10,
			  },
			},
			grid: {
			  row: {
				colors: ['#f3f3f3', 'transparent'],
				opacity: 0.5,
			  },
			},
			xaxis: {
			  categories: $this.action_items_data["ai_assistant_advisor_graph"]['x-axis'],
			},
			yaxis: {
			  labels: {
				// formatter: function (value) {
				//   let val: string | number = Math.abs(value);
				//   if (val >= 10 ** 3 && val < 10 ** 6) {
				// 	val = (val / 1000).toFixed(0) + 'K';
				//   } else if (val >= 10 ** 6) {
				// 	val = (val / 1000000).toFixed(0) + 'M';
				//   } else {
				// 	val = val;
				//   }
				//   return val;
				// },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			  },
			},
		  };

		  var chart = new ApexCharts(document.querySelector('#ai-assistant-graph'), options);
		  chart.render();
	}

	createAdvisorManagerStagesGraph() {
		let $this = this;


		let graph_data: any;

		var options = {
			colors: $this.action_items_data["stage_graph"]['colors'],
			series: $this.action_items_data["stage_graph"]['y-axis'],
			chart: {
				type: 'bar',
				// events: {
				// 	dataPointSelection: function (event, chartContext, config) {
				// 		const details = {
				// 			stage: $this.action_items_data["stage_graph"]["x-axis"][config.dataPointIndex],
				// 			stage_id: $this.action_items_data["stage_graph"]["stage_ids"][config.dataPointIndex],

				// 			status: $this.action_items_data["stage_graph"]["labels"][config.seriesIndex],
				// 			status_id: $this.action_items_data["stage_graph"]["status_ids"][config.seriesIndex],
				// 		};
				// 		$this.graph_activity_status = details.status;
				// 		$this.graph_activity_status_id = details.status_id;

				// 		$this.graph_activity_stage = details.stage;
				// 		$this.graph_activity_stage_id = details.stage_id;
				// 		$this.getActionItemGraphs();
				// 	}
				// },
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
				stacked: true,
				// stackType: '100%'
			},
			plotOptions: {
				bar: {
				horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(document.getElementById('activity-stages-graph').clientWidth, $this.action_items_data["stage_graph"]['x-axis'].length, 40),
					endingShape: 'rounded',
				},
			},
			xaxis: {
				categories: $this.action_items_data["stage_graph"]['x-axis'],
			},
			fill: {
				opacity: 1,
			},
			legend: {
				position: 'bottom',
				offsetX: -10,
				offsetY: 0,
			},
		};

		var chart = new ApexCharts(document.querySelector('#activity-stages-graph'), options);
		chart.render();
	}

	notifications_data_loaded: boolean = false;
	notifications_data: any;
	getNotifications() {
		this.notifications_data_loaded = false;

		// let route: any = "";
		// if (this.user_role == "Advisor Manager") {
		// 	route = "/advisormanagernotificationsnew/"
		// } else if (this.user_role == "Advisor") {
		// 	route = "/advisornotificationsnew/"
		// } else if (this.user_role == "AFA") {
		// 	route = "/afanotificationsnew/"
		// } else if (this.user_role == "Assistant") {
		// 	route = "/assistantnotificationsnew/"
		// } else if (this.user_role == "Relationship Manager") {
		// 	route = "/relationshipmanagernotificationsnew/"
		// }

		const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		let route: any = "";
		if (this.user_role == "Executive") {
			route = "/executivenotifications/" + '?activity_stage=' + this.activity_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Advisor Manager") {
			route = "/advisormanagernewnotifications/" + '?activity_stage=' + this.activity_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Advisor") {
			route = "/advisornotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + "&assigned=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "AFA") {
			route = "/afanotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Assistant") {
			route = "/assistantnotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Relationship Manager") {
			// route = "/relationshipmanagernotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
			route = "/advisornotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + "&assigned=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Leadership") {
			// route = "/leadershipnotifications/" + '?activity_stage=' + this.activity_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
			route = "/recruiternotifications/" + '?activity_stage=' + this.activity_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Marketing Team") {
			route = "/advisornotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + "&assigned=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Lending Officer") {
			route = "/advisornotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + "&assigned=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Insurance Agent") {
			route = "/advisornotificationsnew/" + '?activity_stage=' + this.activity_stage_filter + '&client_stage=' + this.client_stage_filter + '&status=' + this.status_filter + '&importance=' + this.importance_filter + "&assigned=" + this.assigned_filter + '&activity_type=' + this.activity_type_filter;
		} else if (this.user_role == "Wholesaler") {
			route = "/wholesalernotifications/" + '?status=' + this.status_filter + '&importance=' + this.importance_filter + '&activity_type=' + this.activity_type_filter;
		}

		if (userTimezone != "") {
			route = route + "&time_zone=" + userTimezone;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				// this.notifications_data = res["data"]["gen_notifications"];
				this.notifications_data = res["data"];
				this.notifications_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	activities_table_header: any = [];

	executive_manager_header: any = [
		{
			name: "Name",
			key: "advisor_name"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	advisor_manager_header: any = [
		{
			name: "Advisor Name",
			key: "advisor_name"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	advisor_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned to",
			key: "afa_name"
		},
		{
			name: "Notified by",
			key: "notified_by"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	afa_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned to",
			key: "afa_name"
		},
		{
			name: "Notified by",
			key: "notified_by"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	assistant_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned by",
			key: "lead_advisor_full_name"
		},
		{
			name: "Notified to",
			key: "notified_to"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	relationship_manager_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned to",
			key: "afa_name"
		},
		{
			name: "Notified by",
			key: "notified_by"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	leadership_team_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Name",
			key: "advisor_name"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	marketing_team_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned to",
		// 	key: "afa_name"
		// },
		// {
		// 	name: "Notified by",
		// 	key: "notified_by"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	// marketing_team_header: any = [
	// 	{
	// 		name: "Advisor Name",
	// 		key: "advisor_name"
	// 	},
	// 	{
	// 		name: "Type",
	// 		key: "activity_type"
	// 	},
	// 	{
	// 		name: "Status",
	// 		key: "status_name"
	// 	},
	// 	{
	// 		name: "Importance",
	// 		key: "importance"
	// 	},
	// 	{
	// 		name: "Activity Name",
	// 		key: "name"
	// 	},
	// 	{
	// 		name: "Scheduled Date",
	// 		key: "scheduled_date"
	// 	},
	// 	{
	// 		name: "Value/Opportunity",
	// 		key: "opportunity"
	// 	},
	// 	// {
	// 	// 	name: "Importance",
	// 	// 	key: "importance"
	// 	// },
	// 	// {
	// 	// 	name: "Status",
	// 	// 	key: "status_name"
	// 	// },
	// 	// {
	// 	// 	name: "Stage",
	// 	// 	key: "stage"
	// 	// },
	// 	// {
	// 	// 	name: "Type",
	// 	// 	key: "activity_type"
	// 	// },
	// 	{
	// 		name: "Description",
	// 		key: "description"
	// 	}
	// ];

  lending_officer_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned to",
			key: "afa_name"
		},
		{
			name: "Notified by",
			key: "notified_by"
		},
		{
			name: "Description",
			key: "description"
		},
	];

  insurance_agent_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Client Name",
			key: "client_name"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Value/Opportunity",
			key: "opportunity"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "current_stage_name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Assigned to",
			key: "afa_name"
		},
		{
			name: "Notified by",
			key: "notified_by"
		},
		{
			name: "Description",
			key: "description"
		},
	];

	wholesaler_header: any = [
		{
			name: "Advisor Name",
			key: "advisor_name"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	activityDetailsUpdated(event) {
		this.getActionItemGraphs();
	}

	selceted_activity_start_date: any = new Date();
	selceted_activity_end_date: any = new Date();

	getNextDay() {
		const nextDay = new Date(this.selceted_activity_start_date);
		nextDay.setDate(nextDay.getDate() + 1);
		this.selceted_activity_start_date = nextDay;
		this.selceted_activity_end_date = nextDay;

		this.getActionItemGraphs();
	}

	getPreviousDay() {
		const previousDay = new Date(this.selceted_activity_start_date);
		previousDay.setDate(previousDay.getDate() - 1);
		this.selceted_activity_start_date = previousDay;
		this.selceted_activity_end_date = previousDay;

		this.getActionItemGraphs();
	}

	getSelectedDay(date) {
		const currentDate = new Date(date);
		currentDate.setDate(currentDate.getDate());

		this.selceted_activity_start_date = currentDate;
		this.selceted_activity_end_date = currentDate;

		this.getActionItemGraphs();
	}


	getNextWeek() {
		this.selceted_activity_start_date.setDate(this.selceted_activity_start_date.getDate() + 7);
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	getPreviousWeek() {
		this.selceted_activity_start_date.setDate(this.selceted_activity_start_date.getDate() - 7);
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	getSelectedWeek(date) {
		const modified_date = new Date(date);
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);
		// this.selceted_activity_start_date.setDate(date.getDate());
		this.selceted_activity_start_date.setDate(modified_date.getDate());
		this.updateWeekDates(this.selceted_activity_start_date);
	}

	updateWeekDates(date) {
		const today = new Date(date);
		const dayOfWeek = today.getDay();
		const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
		this.selceted_activity_start_date = new Date(today.setDate(diff));
		this.selceted_activity_end_date = new Date(today.setDate(today.getDate() + 6));

		this.getActionItemGraphs();
	}

	updateMonthDates(date) {
		const today = new Date(date);

		// this.selceted_activity_start_date = new Date(today.getFullYear(), today.getMonth(), 1);
		// this.selceted_activity_end_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);

		const start_date = new Date(today.getFullYear(), today.getMonth(), 1);
		const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
		this.selceted_activity_start_date = moment(start_date).startOf('month').format();
        this.selceted_activity_end_date = moment(end_date).endOf('month').format();

		this.getActionItemGraphs();
	}

	getNextMonth() {
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);

		this.selceted_activity_start_date.setMonth(this.selceted_activity_start_date.getMonth() + 1);
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getPreviousMonth() {
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);

		this.selceted_activity_start_date.setMonth(this.selceted_activity_start_date.getMonth() - 1);
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getSelectedMonth(date) {
		const modified_date = new Date(date);
		this.selceted_activity_start_date = new Date(this.selceted_activity_start_date);
		// this.selceted_activity_start_date.setMonth(date.getMonth());
		this.selceted_activity_start_date.setMonth(modified_date.getMonth());
		this.updateMonthDates(this.selceted_activity_start_date);
	}

	getNextYear() {
		const nextYear = new Date(this.selceted_activity_start_date);
		nextYear.setFullYear(nextYear.getFullYear() + 1);

		// this.selceted_activity_start_date = nextYear;
		// this.selceted_activity_end_date = nextYear;

		this.selceted_activity_start_date = moment(nextYear).startOf('year').format();
        this.selceted_activity_end_date = moment(nextYear).endOf('year').format();

		this.getActionItemGraphs();
	}

	getPreviousYear() {
		const previousYear = new Date(this.selceted_activity_start_date);
		previousYear.setFullYear(previousYear.getFullYear() - 1);

		// this.selceted_activity_start_date = previousYear;
		// this.selceted_activity_end_date = previousYear;

		this.selceted_activity_start_date = moment(previousYear).startOf('year').format();
        this.selceted_activity_end_date = moment(previousYear).endOf('year').format();

		this.getActionItemGraphs();
	}

	getSelectedYear(date) {
		const currentYear = new Date(date);
		currentYear.setFullYear(currentYear.getFullYear());

		// this.selceted_activity_start_date = currentYear;
		// this.selceted_activity_end_date = currentYear;

		this.selceted_activity_start_date = moment(currentYear).startOf('year').format();
        this.selceted_activity_end_date = moment(currentYear).endOf('year').format();

		this.getActionItemGraphs();
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
		  return null;
		}
		if (num === 0) {
		  return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		  k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		  c =
			k < 1
			  ? num.toFixed(0 + fixed)
			  : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		  d = c < 0 ? c : Math.abs(c),
		  e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	test() {
		var options = {
			series: [
			  {
				name: 'Line 1 (Solid)',
				data: [10, 20, 30, 40, 60, null, null, null, null]
			  },
			  {
				name: 'Line 2 (Dotted)',
				data: [null, null, null, null, 60, 80, 90, 100, 105]
			  },
			  {
				name: 'Line 3 (Dotted)',
				data: [null, null, null, null, 60, 65, 70, 75, 80]
			  },
			  {
				name: 'Line 4 (Dotted)',
				data: [null, null, null, null, 60, 35, 26, 20, 14]
			  }
			],
			chart: {
			  height: 350,
			  type: 'line'
			},
			stroke: {
			  curve: 'smooth',
			  width: [3, 3, 3, 3], // Line thickness for each series
			  dashArray: [0, 5, 5, 5] // 0 for solid, 5 for dotted
			},
			xaxis: {
			  categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct']
			},
			title: {
			  text: 'Apex Line Chart - Dotted and Solid Lines',
			  align: 'left'
			},
			tooltip: {
			  shared: true,
			  intersect: false
			}
		  };

		  var chart = new ApexCharts(document.querySelector("#test"), options);
		  chart.render();
	}

	navigateToHighValuedOpportunities(type, id) {
		let role: any = "";
		if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
			role = '/insurance-agent';
		}

		this.router.navigate([role + '/my-book/' + type], {queryParams: { stage_id: id}});
	}

  // results_duration_filter: any = "current_year";
  results_duration_filter: any = "previous_year";

  results_data: any;
  results_data_loaded: boolean = false;
  getResultsData() {
    this.results_data_loaded = false;

		let route: any = "/advisorresults/" + '?duration=' + this.results_duration_filter;

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.results_data = res;
				this.results_data_loaded = true;

        setTimeout(() => {
          this.createResultsGraph();
        }, 200);

			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

  }

  createResultsGraph() {

    let $this = this;

		const options = {
			colors: $this.results_data['segment_graph']['colors'],
			series: $this.results_data['segment_graph']['data'],
			chart: {
				type: 'donut',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 335,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.results_data['segment_graph']['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
			},
		};
		var chart = new ApexCharts(document.querySelector('#results-graph'), options);
		chart.render();
  }

  changeResultAction(data){
    const payload = {
			segment: data.segment,
			action: data.action,
			duration: data.duration,
		};
		this.commonService.postData('/relationshipmanageraction/', payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Result Action has been Updated Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
  }

}
